import { render, staticRenderFns } from "./view.vue?vue&type=template&id=10b857a2"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b857a2')) {
      api.createRecord('10b857a2', component.options)
    } else {
      api.reload('10b857a2', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=10b857a2", function () {
      api.rerender('10b857a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faqs/view.vue"
export default component.exports